module.exports = __webpack_public_path__ + "img/p4-1-1.8deac891.png";